import { useCallback, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { toast } from 'react-toastify';

import {
  Content,
  Section,
  Div,
  InputSection,
  Typography,
  SectionHeaderDrawer,
} from './styles';

import {
  getCompanyByIdRequest,
  updateUserProfileOnCompanyRequest,
} from '../../../services';

import useAuthStore from '../../../store/auth';
import useCompanyStore from '../../../store/companies';

interface EditarMembroProps {
  setOpenDrawerAddMember: (open: boolean) => void;
  userEdit: any;
  setUserEdit: any;
}

export const EditarMembro = ({
  setOpenDrawerAddMember,
  userEdit,
  setUserEdit,
}: EditarMembroProps) => {
  const params = useParams();

  const userFromStorage = useAuthStore(state => state.user);
  const selectCompany = useCompanyStore(state => state.selectedCompany);
  const setSelectCompany = useCompanyStore(state => state.setSelectedCompany);

  const [profileSelected, setProfileSelected] = useState('');

  const userInCompany = selectCompany?.users?.find(
    u => u.id === userFromStorage?.id,
  );

  useEffect(() => {
    if (userEdit && Object.keys(userEdit).length > 0) {
      setProfileSelected(userEdit.profile);
    }
  }, [userEdit]);

  const handleChangePermission = (event: SelectChangeEvent) => {
    setProfileSelected(event.target.value);
  };

  const loadCompany = useCallback(async () => {
    try {
      const response = await getCompanyByIdRequest(selectCompany?.id as string);

      if (response?.status === 200) {
        setSelectCompany(response?.data);
      }
    } catch (err) {
      console.log(err);
    }
  }, [selectCompany?.id, setSelectCompany]);

  const handleEditUser = useCallback(async () => {
    try {
      if (params?.id) {
        const response = await updateUserProfileOnCompanyRequest(
          selectCompany?.id as string,
          userEdit?.id,
          profileSelected,
          userFromStorage?.id as string,
        );

        if (response?.status === 200) {
          setUserEdit({ ...userEdit, profile: profileSelected });
          toast.success('Permissionamento editado com sucesso');
          setOpenDrawerAddMember(false);
          loadCompany();
        }
      }
    } catch (err) {
      console.log(err);
    }
  }, [
    params?.id,
    selectCompany?.id,
    userEdit,
    profileSelected,
    userFromStorage?.id,
    setUserEdit,
    setOpenDrawerAddMember,
    loadCompany,
  ]);

  const validateUser = () => {
    if (userInCompany?.profile === 'UN1' || userInCompany?.profile === 'UN2') {
      return false;
    }
    if (params?.id === userFromStorage?.id) {
      return false;
    }
    if (window.location.href.includes('dados-pessoais')) {
      return false;
    }
    return true;
  };

  return (
    <Box sx={{ width: '560px', height: '100%' }} role="presentation">
      <Content>
        <SectionHeaderDrawer>
          <CloseRounded
            sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
            onClick={() => setOpenDrawerAddMember(false)}
          />
          <Typography>Editar Permissionamento</Typography>
        </SectionHeaderDrawer>
        <Section>
          <Div className="content-Edit">
            <InputSection>
              {(userInCompany?.profile === 'UN1' ||
                userInCompany?.profile === 'UN2') &&
                params?.id && (
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-autowidth-label">
                      Selecione
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={profileSelected}
                      onChange={handleChangePermission}
                      autoWidth
                      label="Selecione"
                    >
                      <MenuItem value="UN2">Admin</MenuItem>
                      <MenuItem value="UN3">Membro</MenuItem>
                    </Select>
                  </FormControl>
                )}
            </InputSection>
          </Div>
          <Box width="100%" display="flex" justifyContent="end">
            <Button
              type="button"
              variant="contained"
              color="success"
              onClick={handleEditUser}
              disabled={validateUser()}
              sx={{
                width: '197px',
                height: '42px',
                color: '#FFFFFF',
                fontSize: '15px',
                fontWeight: '500',
                whiteSpace: 'nowrap',
              }}
            >
              Salvar Alterações
            </Button>
          </Box>
        </Section>
      </Content>
    </Box>
  );
};
